import React, { FC, useCallback } from 'react'
import { gql, useQuery } from '@apollo/client'
import { LinkButton } from '@/atoms/Button'
import { FlexRow } from '@/atoms/FlexContainers'
import { AngelLogo } from '@/atoms/Logos/AngelLogo'
import { CaptionSM } from '@/atoms/Text'
import { Avatar } from '@/molecules/Avatar'
import { useUser } from '@/services/UserService'
import { GetTotalEntriesQuery, GetTotalEntriesQueryVariables } from '@/types/codegen-federation'
import { useLoginUrl } from '@/utils/auth-utils'
import { Translate, useTranslate } from '@/utils/translate/translate-client'

export const GET_TOTAL_ENTRIES = gql`
  query getTotalEntries($input: GetTheatricalPresalesSummaryInput!) {
    getTheatricalPresalesSummary(input: $input) {
      sweepstakesSummary {
        totalEntries
      }
    }
  }
`
interface Props {
  theatricalSlug: string
}
const GiveawayNav: FC<Props> = ({ theatricalSlug }) => {
  const { loginUrl, trackLoginStarted } = useLoginUrl(`/pre-sales/${theatricalSlug}/giveaway`)
  const { user } = useUser()
  const { t } = useTranslate('tickets')
  const { data } = useQuery<GetTotalEntriesQuery, GetTotalEntriesQueryVariables>(GET_TOTAL_ENTRIES, {
    variables: { input: { projectSlug: theatricalSlug } },
  })

  const totalEntries = data?.getTheatricalPresalesSummary?.sweepstakesSummary?.[0]?.totalEntries ?? 0

  const onAccountClick = useCallback(() => {
    return window?.open('/account?t=myTickets', '_blank', 'noopener,noreferrer')
  }, [])

  return (
    <nav className="relative flex items-center justify-between">
      <AngelLogo color="white" height={32} />

      <FlexRow className="gap-4">
        {totalEntries && totalEntries > 0 ? (
          <a
            className="homestead-eyebrow-md rounded-md bg-homestead-yellow px-2 py-1 uppercase"
            href={`/pre-sales/${theatricalSlug}/giveaway/summary`}
            target="_blank"
          >
            {totalEntries} {t('giveawayEntries', 'Entries')}
          </a>
        ) : null}

        {user ? (
          <div className="w-fit overflow-hidden rounded-full border-2 border-black bg-cover ring-2 ring-white">
            <Avatar onClick={onAccountClick} />
          </div>
        ) : (
          <div className="flex items-center">
            <LinkButton
              href={loginUrl}
              variant="white"
              outline
              className="box-border h-8 rounded-md backdrop-blur-sm"
              onClick={() => trackLoginStarted('top-nav')}
            >
              <CaptionSM className="whitespace-nowrap">
                <Translate t={t} i18nKey="logIn">
                  Log In
                </Translate>
              </CaptionSM>
            </LinkButton>
          </div>
        )}
      </FlexRow>
    </nav>
  )
}

export default GiveawayNav
